<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <h5 class="info-text">
            ¿Cómo iniciarás sesión y dónde te contactamos?
          </h5>
          <div
            v-if="!activeCamera"
            class="md-layout-item md-size-40 md-small-size-100 mx-auto"
          >
            <h5 class="md-layout-item">
              Necesitaremos que te tomes una foto para asegurarnos de que eres
              la persona de la cédula.
            </h5>
            <h5 class="md-layout-item">
              Si te estás registrando desde tu computador y no tiene cámara o la
              calidad es muy baja, te recomendamos registrarte desde el celular.
            </h5>
            <md-button
              class="md-layout-item md-success"
              @click.prevent="
                {
                  activeCamera = true;
                }
              "
            >
              Abrir Cámara
            </md-button>
          </div>
          <PhotoCapture v-else v-model="input" />
          <ValidationProvider
            name="email"
            rules="required|email"
            v-slot="{ passed, failed }"
          >
            <md-field
              :class="[
                { 'md-error': failed },
                { 'md-valid': passed },
                { 'md-form-group': true }
              ]"
            >
              <md-icon>email</md-icon>
              <label>Correo</label>
              <md-input v-model="model.email" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider
            name="password"
            rules="required|confirmed:passConfirmation|min:6"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Contraseña</label>
              <md-input v-model="model.password" type="password"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider
            vid="passConfirmation"
            rules="required|min:6"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Confirmar Contraseña</label>
              <md-input v-model="passConfirmation" type="password"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider
            name="cellphone"
            rules="required|max_value:3999999999|min_value:3000000000"
            v-slot="{ passed, failed }"
          >
            <md-field
              :class="[
                { 'md-error': failed },
                { 'md-valid': passed },
                { 'md-form-group': true }
              ]"
            >
              <md-icon>phone</md-icon>
              <label>Celular</label>
              <md-input v-model="model.cellphone" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider
            name="capDomainCellPType"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field
              :class="[
                { 'md-error': failed },
                { 'md-valid': passed },
                { 'md-form-group': true }
              ]"
            >
              <md-icon>settings_phone</md-icon>
              <label for="select">Tipo de plan</label>
              <md-select
                v-if="planTypes"
                v-model="capDomainCellPType"
                name="select"
              >
                <md-option
                  v-for="planType in planTypes"
                  :key="planType.id"
                  :value="planType.id"
                  >{{ planType.value }}</md-option
                >
              </md-select>
              <h4 v-else>{{ error }}</h4>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider
            name="capDomainCellPType"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field
              :class="[
                { 'md-error': failed },
                { 'md-valid': passed },
                { 'md-form-group': true }
              ]"
            >
              <md-icon>question_answer</md-icon>
              <label for="select">Pregunta de seguridad 1</label>
              <md-select
                v-if="securityQuestions"
                v-model="pSecurityQuestions[0]"
                name="select"
              >
                <md-option
                  v-for="securityQuestion in securityQuestions"
                  :key="securityQuestion.id"
                  :value="securityQuestion.id"
                  >{{ securityQuestion.text }}</md-option
                >
              </md-select>
              <h4 v-else>{{ error }}</h4>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider
            name="firstLastName"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field
              :class="[
                { 'md-error': failed },
                { 'md-valid': passed },
                { 'md-form-group': true }
              ]"
            >
              <md-icon>verified_user</md-icon>
              <label>Respuesta 1</label>
              <md-input v-model="securityAnswers[0].answer" type="text">
              </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider
            name="capDomainCellPType"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field
              :class="[
                { 'md-error': failed },
                { 'md-valid': passed },
                { 'md-form-group': true }
              ]"
            >
              <md-icon>question_answer</md-icon>
              <label for="select">Pregunta de seguridad 2</label>
              <md-select
                v-if="securityQuestions"
                v-model="pSecurityQuestions[1]"
                name="select"
              >
                <md-option
                  v-for="securityQuestion in securityQuestions"
                  :key="securityQuestion.id"
                  :value="securityQuestion.id"
                  >{{ securityQuestion.text }}</md-option
                >
              </md-select>
              <h4 v-else>{{ error }}</h4>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider
            name="firstLastName"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field
              :class="[
                { 'md-error': failed },
                { 'md-valid': passed },
                { 'md-form-group': true }
              ]"
            >
              <md-icon>verified_user</md-icon>
              <label>Respuesta 2</label>
              <md-input v-model="securityAnswers[1].answer" type="text">
              </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider
            name="capDomainCellPType"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field
              :class="[
                { 'md-error': failed },
                { 'md-valid': passed },
                { 'md-form-group': true }
              ]"
            >
              <md-icon>question_answer</md-icon>
              <label for="select">Pregunta de seguridad 3</label>
              <md-select
                v-if="securityQuestions"
                v-model="pSecurityQuestions[2]"
                name="select"
              >
                <md-option
                  v-for="securityQuestion in securityQuestions"
                  :key="securityQuestion.id"
                  :value="securityQuestion.id"
                  >{{ securityQuestion.text }}</md-option
                >
              </md-select>
              <h4 v-else>{{ error }}</h4>
            </md-field>
          </ValidationProvider>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider
            name="firstLastName"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field
              :class="[
                { 'md-error': failed },
                { 'md-valid': passed },
                { 'md-form-group': true }
              ]"
            >
              <md-icon>verified_user</md-icon>
              <label>Respuesta 3</label>
              <md-input v-model="securityAnswers[2].answer" type="text">
              </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>
        <modal
          v-if="valueLoading != 0 && valueLoading != 100"
          @close="noticeModalHide"
        >
          <template slot="header">
            <h4 class="modal-title">{{ messageLoading }}</h4>
            <md-button
              class="md-simple md-just-icon md-round modal-default-button"
              @click="noticeModalHide"
            >
              <md-icon>clear</md-icon>
            </md-button>
          </template>

          <template slot="body">
            <md-progress-bar
              class="md-primary"
              md-mode="buffer"
              :md-value="valueLoading"
              :md-buffer="valueLoading"
            ></md-progress-bar>
            <p>
              Creando cuenta y validando identidad.
            </p>
          </template>
        </modal>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, email, confirmed } from "vee-validate/dist/rules";
import Constants from "../../../constants";
import gql from "graphql-tag";
import Swal from "sweetalert2";
import PhotoCapture from "../../components/PhotoCapture";
import { Modal } from "@/components";

extend("email", email);
extend("required", required);
extend("confirmed", confirmed);

export default {
  props: {
    messageLoading: String,
    valueLoading: Number
  },
  components: {
    SlideYDownTransition,
    PhotoCapture,
    Modal
  },
  created() {
    this.$apollo
      .query({
        query: gql`
          query getDomain($fieldName: String!) {
            getDomain(fieldName: $fieldName) {
              id: domId
              name: fieldName
              value: fieldValue
            }
          }
        `,
        variables: {
          fieldName: Constants.DOMAIN_PLAN_TYPE
        }
      })
      .then(data => {
        this.planTypes = data.data.getDomain;
      })
      .catch(error => {
        console.log(error.networkError);
        if (error.graphQLErrors[0]) this.error = error.graphQLErrors[0].message;
        else if (error.networkError)
          this.error = "Ha ocurrido un error de conexión";
        else this.error = "Ha ocurrido un error desde el servidor";
      });
    this.$apollo
      .query({
        query: gql`
          query getSecurityQuestions {
            getSecurityQuestions {
              id: secQuestionId
              text: secQText
            }
          }
        `
      })
      .then(data => {
        this.securityQuestions = data.data.getSecurityQuestions;
      })
      .catch(error => {
        console.log(error.networkError);
        if (error.graphQLErrors[0]) this.error = error.graphQLErrors[0].message;
        else if (error.networkError)
          this.error = "Ha ocurrido un error de conexión";
        else this.error = "Ha ocurrido un error desde el servidor";
      });
  },
  data() {
    return {
      modalAdress: false,
      error: null,
      model: {
        email: "",
        password: "",
        cellphone: null
      },
      capDomainCellPType: null,
      activeCamera: false,
      input: null,
      videoUrl: null,
      planTypes: null,
      passConfirmation: "",
      securityQuestions: null,
      securityAnswers: [{ answer: null }, { answer: null }, { answer: null }],
      pSecurityQuestions: []
    };
  },
  methods: {
    noticeModalHide: function() {
      this.modalAdress = false;
    },
    validate() {
      return this.$refs.form.validate().then(res => {
        if (!res) {
          return;
        } else if (this.input == null)
          Swal.fire({
            title: "¡Falta algo!",
            text: "No olvides tomarte la foto del rostro",
            timer: 2000,
            showConfirmButton: false
          });
        else if (
          this.pSecurityQuestions[0] == this.pSecurityQuestions[1] ||
          this.pSecurityQuestions[2] == this.pSecurityQuestions[1] ||
          this.pSecurityQuestions[0] == this.pSecurityQuestions[2]
        )
          Swal.fire({
            title: "¡Corrige las preguntas!",
            text: "Las 3 preguntas de seguridad deben ser diferentes",
            timer: 2000,
            showConfirmButton: false
          });
        else
          this.$emit(
            "on-validated",
            res,
            this.model,
            this.input,
            this.capDomainCellPType,
            this.pSecurityQuestions,
            this.securityAnswers
          );
        return res;
      });
    }
  }
};
</script>
<style></style>
